import Image from "next/future/image";
import ButtonArrow from "../reusable/ButtonArrow";

export default function Joinus() {
  return (
    <section id="joinus" className="flex flex-col md:flex-row items-center bg-[#051747]">
      <div className="w-[100%] py-[70px] md:py-0 text-white md:w-[50%] pl-[5vw] md:pl-[100px]">
        <h1 className="text-4xl  sm:text-6xl ">Careers</h1>
        <p className="pt-8 text-xl sm:text-3xl font-light leading-relaxed">
          Are you inspired by doing great work? <br /> We're too. Join us.
        </p>
        <ButtonArrow txt="Know more" link="/career" style="w-[170px] text-gray-200 [&>div]:border-gray-400 " />
      </div>
      <section>
        <Image
          src="/career/careers.webp"
          className="w-[100vw] md:w-auto md:h-[100vh] md:min-h-[104vh] mx-auto object-cover"
          width="500"
          height="500"
          alt={"how-digitisation-helps-formulation-companies"}
          sizes="(max-width: 500px) 50vw,
            (max-width: 1200px) 70vw, 100vw"
          placeholder="blur"
          blurDataURL="/career/careers.webp"
        />
      </section>
    </section>
  );
}



// import Image from "next/future/image";
// import ButtonArrow from "../reusable/ButtonArrow";

// export default function Joinus() {
//   return (
//     <section id="joinus" className="flex flex-col-reverse md:flex-row items-center">
//       <section >
//         <Image
//           src="/contactushome/pexels-alejandro.webp"
//           className="w-[100vw] md:w-auto md:h-[100vh] md:min-h-[104vh] mx-auto object-cover"
//           width="500"
//           height="500"
//           alt={"how-digitisation-helps-formulation-companies"}
//           sizes="(max-width: 500px) 50vw,
//             (max-width: 1200px) 70vw, 100vw"
//           placeholder="blur"
//           blurDataURL="/contactushome/pexels-alejandro.webp"
//         />
//       </section>

//       <div className="w-[100%] py-[70px] md:py-0 text-white md:w-[50%] pl-[5vw] md:pl-[100px">
//         <h1 className="text-4xl  sm:text-6xl text-black">Are you inspired by doing great work? <br/>  <small className="text-2xl sm:text-4xl text-gray-500">We're too.</small> </h1>
//         {/* <p className="pt-8 text-xl sm:text-3xl font-light leading-relaxed text-black">
          
//         </p> */}
//         <ButtonArrow txt="Join us" link="/career" style="w-[170px] text-black bg-[#f1aa4e] [&>div]:border-gray-400 text-center" />
//       </div>
      
//     </section>
//   );
// }
